<template>
  <div class="content-wrapper">
    <SendGiftMenu
      header="Manage Templates"
      backTo="/shopping-bag"
      :displayShoppingBag="false"
    />
    <div v-if="!loadStatus">
      <Skeleton width="100%" height="3.5rem" v-for="i in 15" :key="i" />
    </div>
    <template v-if="loadStatus">
      <!-- Template Button Here -->
      <div class="flex justify-end mb-3">
        <button
          class="button-gemnote full-width button-gemnote--small"
          @click="$router.push('/manage-templates/new')"
        >
          <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M6 0L6 13" stroke="#F5F2EE" />
            <path d="M0 6.5L13 6.5" stroke="#F5F2EE" />
          </svg>

          <span>Add card template</span>
        </button>
      </div>

      <TemplatesList :templatesList="cardTemplatesList" />
      <Pagination
        :total-items="totalRecords"
        :page="serverParams.page"
        :items-per-page="serverParams.perPage"
        @page-change="pageChange"
        @perPageChange="handlePerPageChange"
      />
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { progressStatus, layouts, storeModules } from '../../helpers'
import SendGiftMenu from '@/components/SendGiftMenu'
import TemplatesList from '@/components/CardTemplates/TemplatesList'
import store from '../../store'

export default {
  name: 'CardTemplatesMain',
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (
      store.state.team.team.teamModuleNames.includes(storeModules.swag_store)
    ) {
      next()
    } else if (
      store.state.team.team.teamModuleNames.includes(storeModules.project)
    ) {
      next({ name: 'Projects' })
    }
  },
  components: {
    SendGiftMenu,
    TemplatesList,
    Skeleton: () => import('@/components/Universal/Skeleton'),
    Pagination: () => import('@/components/Universal/Pagination')
  },
  data: () => ({
    serverParams: {
      page: 0,
      perPage: 50
    }
  }),

  computed: {
    loadStatus() {
      return progressStatus(this.loadCardTemplates)
    },
    ...mapState({
      loadCardTemplates: state => state.cardTemplate.loadCardTemplates,
      cardTemplatesList: state => state.cardTemplate.cardTemplatesList,
      totalRecords: state => state.cardTemplate.totalRecords
    })
  },
  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
    this.getCardTemplates({
      page: 1,
      perPage: this.serverParams.perPage
    })
  },
  methods: {
    ...mapActions('cardTemplate', ['getCardTemplates']),
    pageChange(page) {
      this.updateParams({ page: page })
      this.getNextChuckOfCardTemplates()
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps)
    },
    handlePerPageChange(e) {
      this.serverParams.perPage = e
      this.getNextChuckOfCardTemplates()
    },
    getNextChuckOfCardTemplates() {
      this.getCardTemplates({
        page: this.serverParams.page + 1,
        perPage: this.serverParams.perPage
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.button-gemnote--small {
  width: auto;
  height: 2.5rem;
  padding: 0 1.25rem;

  svg {
    margin-right: 8px;
  }
}

.margin {
  margin-bottom: 1rem;
}

.mb-3 {
  margin-bottom: 2rem;
}
</style>
